module.exports = __webpack_public_path__ + "static/img/8-3.4bee3ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8-3.jpg
// module id = tNoF
// module chunks = 0